<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <p>
          If you wish to use Nuvita Pro in an advanced mode, check the 'Advanced
          Dashboard' option.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <input
          type="checkbox"
          id="isAdvanced"
          v-model="isAdvanced"
          class="z-checkbox-small"
        />
        <label for="isAdvanced" class="custom-is">Advanced Dashboard</label>
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p>
          To restore any of the following "hidden" panels, check the appropriate
          panel name and click the "Restore" button.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <input
          type="checkbox"
          id="isUsers"
          v-model="isUsers"
          class="z-checkbox-small"
        />
        <label for="isUsers" class="custom-is">Users</label>
      </div>
      <div class="col-md-6"></div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'user-options',
  computed: {
    ...mapGetters('users', ['user']),
    isAdvanced: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.isAdvanced
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'isAdvanced',
          value: value,
        })
      },
    },
    isUsers: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.isUsers
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'isUsers',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('users', ['setUserData']),
  },
}
</script>
<style scoped>
</style>
